<template>
    <div>
        <v-data-table
            :loading="loader"
            disable-initial-sort
            :rows-per-page-items="rowPerPage"
            :headers="headers"
            :items="filtered_items"
            item-key="id"
        >
            <template #headers="props">
                <tr>
                    <th
                        :class="['fw-bold', `text-xs-${header.align}`]"
                        v-for="header in props.headers"
                        :key="header.text"
                    >{{ header.text }}</th>
                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td class="text-center text-no-wrap">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon small color="#464D69">settings</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile
                                    v-if="!props.item.room_state_id"
                                    @click="openDialog(props.item, 'activate')"
                                >
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-wifi-alt"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Kích hoạt Internet</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                    v-if="props.item.room_state_id"
                                    @click="openDialog(props.item, 'cancel')"
                                >
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-wifi-off"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Ngừng sử dụng internet</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="openDialog(props.item, 'change')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-refresh-alt"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Chuyển mạng</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                    v-if="!props.item.room_state_id"
                                    @click="openDialog(props.item, 'cut')"
                                >
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-cloud-off"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Cắt line VNPT</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                    <td class="text-left text-no-wrap">{{ props.item.user }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">
                        <span
                            :class="['v-badge', internet_status[props.item.status].badge]"
                        >{{ internet_status[props.item.status].text }}</span>
                    </td>
                    <td class="text-center text-no-wrap">{{ props.item.price | formatNumber }}</td>
                    <td
                        class="text-center text-no-wrap"
                    >{{ props.item.date_schedule_out | formatTimeServer }}</td>
                    <td
                        class="text-center text-no-wrap"
                    >{{ props.item.date_start | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.wifi_name }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.wifi_password }}</td>
                </tr>
            </template>
            <template #no-data>Chưa có thông tin</template>
        </v-data-table>
        <change-room-id-dialog
            @changeDialogState="change_room_id_dialog = $event"
            @updateInternetUser="updateInternetUser"
            :dialog="change_room_id_dialog"
            :internet_user="chosen_internet_user"
        ></change-room-id-dialog>
        <activate-internet-dialog
            @changeDialogState="activate_internet_dialog = $event"
            @updateInternetUser="updateInternetUser"
            :dialog="activate_internet_dialog"
            :internet_user="chosen_internet_user"
        ></activate-internet-dialog>
        <cancel-internet-room-dialog
            @changeDialogState="cancel_internet_dialog = $event"
            @updateInternetUser="updateInternetUser"
            :dialog="cancel_internet_dialog"
            :internet_user="chosen_internet_user"
        ></cancel-internet-room-dialog>
        <cut-internet-dialog
            @changeDialogState="cut_internet_dialog = $event"
            @reloadTable="getData"
            :dialog="cut_internet_dialog"
            :internet_user="chosen_internet_user"
        ></cut-internet-dialog>
        <export-csv-button
            :trigger="export_csv.trigger"
            :title="export_csv.title"
            :rows="export_csv.rows"
        ></export-csv-button>
    </div>
</template>
<script>
import api from "../../api";
import ChangeRoomIdDialog from "./InternetChangeRoomId";
import ActivateInternetDialog from "./ActivateInternet";
import CancelInternetRoomDialog from "./CancelInternetRoom";
import CutInternetDialog from "./CutInternet";
import { list_building } from "../../constants/db-config";
import ExportCsvButton from "../../components/ExportExcel/ExportCsvButton";
import { buildParamQuery, formatTimeServer } from "../../helpers/helpers.js";

export default {
    props: {
        reload_table: Number,
        search: String,
        chosen_building: String,
        exportCSV: Number // trigger CSV
    },
    components: {
        ChangeRoomIdDialog,
        ActivateInternetDialog,
        CancelInternetRoomDialog,
        CutInternetDialog,
        ExportCsvButton
    },
    name: "internet-table",
    data() {
        return {
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                {
                    text: "Tên user",
                    align: "left",
                    sortable: true,
                    value: "user"
                },
                {
                    text: "Số phòng",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Trạng thái",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Giá gói",
                    align: "center",
                    sortable: true,
                    value: "price"
                },
                {
                    text: "Ngày hẹn trả phòng",
                    align: "center",
                    sortable: true,
                    value: "date_schedule_out"
                },
                {
                    text: "Ngày bắt đầu",
                    align: "center",
                    sortable: true,
                    value: "date_start"
                },
                {
                    text: "Tên Wifi",
                    align: "center",
                    sortable: true,
                    value: "wifi_name"
                },
                {
                    text: "Pass Wifi",
                    align: "center",
                    sortable: true,
                    value: "wifi_password"
                }
            ],
            items: [],
            loader: false,
            rowPerPage: [50, 100, 200, { text: "Tất cả", value: -1 }],
            change_room_id_dialog: false,
            activate_internet_dialog: false,
            cancel_internet_dialog: false,
            cut_internet_dialog: false,
            chosen_internet_user: {},
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
            internet_status: {
                "0": {
                    text: "Mạng trống",
                    badge: "error"
                },
                "1": {
                    text: "Đang hoạt động",
                    badge: "primary"
                },
                "2": {
                    text: "Trả phòng",
                    badge: "warning"
                }
            }
        };
    },
    computed: {
        filtered_items() {
            const search = this.search && this.search.toLowerCase();
            return this.items.filter(item => {
                if (
                    item.building &&
                    item.room_id &&
                    item.building.includes(this.chosen_building) &&
                    item.room_id.toLowerCase().includes(search)
                )
                    return true;
                if (item.user.includes(search))
                    return item.building.includes(this.chosen_building);
                return false;
            });
        }
    },
    watch: {
        reload_table() {
            this.getData();
        },
        exportCSV() {
            this.startExportCSV();
        }
    },
    methods: {
        getData: async function() {
            this.items = [];
            this.loader = true;
            let data = await api.getListInternet();
            this.loader = false;
            if (data.status === 200) {
                this.items = data.data.internet.map(item => {
                    const building = list_building.find(
                        building => building.value == item.building
                    );
                    item.building_text = building.text;

                    item.status = this.updateItemStatus(item);
                    return item;
                });
            } else {
                console.log("Lỗi lúc tải phiếu thu");
            }
        },
        updateItemStatus: function(item) {
            if (!item.room_state_id) return 0;
            else if (!item.date_schedule_out) return 1;
            return 2;
        },
        openDialog(internet_user, action) {
            if (action === "change") this.change_room_id_dialog = true;
            else if (action === "activate")
                this.activate_internet_dialog = true;
            else if (action === "cancel") this.cancel_internet_dialog = true;
            else if (action === "cut") this.cut_internet_dialog = true;
            this.chosen_internet_user = internet_user;
        },
        updateInternetUser(internet_user) {
            const selected_user = this.items.find(
                user => user._id === internet_user._id
            );
            for (const key in selected_user) {
                if (
                    selected_user.hasOwnProperty(key) &&
                    internet_user.hasOwnProperty(key)
                ) {
                    const element = internet_user[key];
                    selected_user[key] = element;
                }
            }
            selected_user.status = this.updateItemStatus(selected_user);
        },
        startExportCSV() {
            const rows = this.filtered_items.map(item => {
                return {
                    "Tên user": item.user,
                    "Tòa nhà": item.building,
                    "Số phòng": item.room_id,
                    "Trạng thái": this.internet_status[item.status].text,
                    "Giá gói": item.price,
                    "Ngày hẹn trả phòng": formatTimeServer(
                        item.date_schedule_out
                    ),
                    "Ngày bắt đầu": formatTimeServer(item.date_start),
                    "Tên Wifi": item.wifi_name,
                    "Pass Wifi": item.wifi_password
                };
            });
            this.export_csv.rows = rows;
            const date = new Date().toISOString().substr(0, 10);
            this.export_csv.title = "internet-" + date;
            this.export_csv.trigger = !this.export_csv.trigger;
        }
    }
};
</script>
<style scoped>
.v-list__tile__action {
    min-width: 30px;
}
</style>